import axios from 'axios';
import md5 from 'md5';

const CHANNEL = '9fztgw';
const SERVER_ID = 200;
const httpTimeOut = 50000;

// 域名配置
const domain = {
  gwDomain: process.env.NODE_ENV === 'production'
    ? 'https://api.9fzt.com/gw'
    : 'https://test-api.techgp.cn/gw',
  // gwDomain: process.env.NODE_ENV === 'production'
  //   ? 'https://test-api.techgp.cn/gw'
  //   : 'https://test-api.techgp.cn/gw',
  getWay: process.env.NODE_ENV === 'production'
    ? 'https://gateway.chongnengjihua.com'
    : 'https://test-gateway.jinyi999.cn',
};

// API服务路径配置
const apiServer = {
  rjhyEduUranus: '/gw/rjhy-edu-uranus/api/1',
  rjhyQuotaIndex: '/rjhy-quota-index',
};

const createSign = (config) => {
  const signStr = 'dac3ef6859f44e439c88cbc28d65880a';
  const timestamp = new Date().getTime();
  let body = '';
  const params = config.paramsData || config.data || config.params;
  const { method, headers } = config;

  if (method.toLowerCase() === 'post') {
    const contentType = headers['Content-Type'] || headers['content-type'];
    if (!contentType) {
      body = JSON.stringify(params || '');
    } else {
      if (contentType.includes('application/x-www-form-urlencoded')) {
        body = sortJoinParams(params);
      } else {
        body = JSON.stringify(params || '');
      }
    }
  } else {
    body = sortJoinParams(params);
  }

  const signature = md5(signStr + body + timestamp);
  return {
    signature,
    timestamp,
  };
};

const sortJoinParams = (params) => {
  const valueArr = [];
  if (params) {
    const sortedObjKeys = Object.keys(params).sort();
    for (const index in sortedObjKeys) {
      valueArr.push(params[sortedObjKeys[index]]);
    }
  }
  return valueArr.join('');
};


const getBasicUrl = (urlConfig = { apiServer: 'rjhyEduUranus', domain: 'gwDomain' }) => {
  return `${domain[urlConfig.domain]}${apiServer[urlConfig.apiServer]}`;
};

const getDefaultResponse = (requestKey) => {
  return {
    code: -1,
    data: null,
    message: 'request error',
    requestKey,
  };
};

// 创建axios实例
const service = axios.create({
  timeout: httpTimeOut,
});

service.interceptors.request.use(
  (config) => {
    // 根据参数处理baseUrl
    config.baseURL = getBasicUrl(config.urlConfig);

    // 处理sign逻辑
    if (config.sign) {
      config.headers = Object.assign(
        {
          appcode: CHANNEL,
          clienttype: 'h5',
          serverId: SERVER_ID,
          appVersion: '3.15.2',
        },
        createSign(config),
        config.headers
      );
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    // 根据http Code和data.code统一处理error
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        return response.data.data || response.data;
      }
      return getDefaultResponse(
        (response.config.urlConfig && response.config.urlConfig.requestKey) || null
      );
    } else {
      return getDefaultResponse(
        (response.config.urlConfig && response.config.urlConfig.requestKey) || null
      );
    }
  },
  (error) => {
    console.log(
      'url:',
      error.config.baseURL + error.config.url,
      ';message:',
      error.message
    );
    return getDefaultResponse(
      (error.config.urlConfig && error.config.urlConfig.requestKey) || null
    );
  }
);

export default service;
